import BaseService from './baseService';
import {generateUrlQueryString} from '@/services/utilities';

class Products extends BaseService {
	async getProducts(opts = {}) {
    this.endPoint = '/products-v2?'+generateUrlQueryString(opts);
		return this.get(opts);
  }
	async getProductCategory(opts = {}) {
    this.endPoint = '/product-categories/category-have-products?'+generateUrlQueryString(opts);
		return this.get(opts);
  }
	async getItems(opts = {}) {
    this.endPoint = '/items';
		return this.get(opts);
  }
  async updateItems(id,payload,opts={}){
    this.endPoint = '/items';
    return await this.putOne(id,payload,opts);
  }
  async createProducts(payload){
    this.endPoint = '/products';
    return await this.post(payload); 
  }
  async updateProducts(id,payload,opts={}){
    this.endPoint = '/products';
    return await this.putOne(id,payload,opts);
  }
  async deleteProducts(id,opts={}){
    this.endPoint = '/products';
    return await this.delete(id,opts);
  }
}

export default new Products();